import {
  propertyChange,
  requestPasswordReset,
  resetPassword,
  TOKEN_SENT_SUCCESSFULLY,
  USERNAME,
  validateToken
} from "../../../ducks/forgotPassword";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ForgotPassword from "./ForgotPassword";
import { LANGUAGE } from "../../../ducks/languageSelector";
import { clearMessages } from "../../../ducks/message";
import { FORGOT_PASSWORD_STORE, LANGUAGE_SELECTOR } from "../../../common/constant";

const mapStateToProps = (state) => {
  return {
    locale: state[LANGUAGE_SELECTOR][LANGUAGE],
    username: state[FORGOT_PASSWORD_STORE][USERNAME],
    tokenSentSuccessfully: state[FORGOT_PASSWORD_STORE][TOKEN_SENT_SUCCESSFULLY]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      propertyChange,
      requestPasswordReset,
      validateToken,
      resetPassword,
      clearMessages
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
